module.exports = __webpack_public_path__ + "static/img/4.7b23948.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/4.png
// module id = 7vXf
// module chunks = 0